document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('.product-meta__taxes-included.text--small');
  const insertAfterElement = document.querySelector('.tee-block.tee-product-price');
  if (elementToMove && insertAfterElement) {        
    insertAfterElement.after(elementToMove)
  } 

  setTimeout(() => {
    addBadgesToVariant();
  }, 1000);
});


const addBadgesToVariant = () => {
  const options = window.teeinblueBadges;
  if(!options) return;

  options.forEach(option => {
    var l = document.querySelector(`.tee-radio:has(label[title="${option.name}"])`);
    if(l) {
      l.classList.add('has-badge');
      l.setAttribute('badge', `${option.badge}`)
      
      const styleId = `badge-style-${option.name.replace(/\s+/g, '-')}`; // unique id
      let styleEl = document.getElementById(styleId);
      
      if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = styleId;
        document.head.appendChild(styleEl);
      }
      
      styleEl.textContent = `
        .tee-radio[badge="${option.badge}"]::after {
          content: "${option.badge}";
          position: absolute;
          top: -12px;
          right: 10px;
          background-color: #C9E6D8;
          padding: 2px 5px;
          border-radius: 5px;
          color: rgb(15, 83, 53);
          font-size: 10px;
        }
      `;
    }
  })
}